import React from 'react';
import axios from 'axios';
import Head from 'next/head';
import { Element, scroller } from 'react-scroll';
import Error from 'next/error';
import { Row, Input, Container, Form, FormGroup, Button, FormFeedback } from 'reactstrap';
import Router from 'next/router';
import Page from '../components/page';
import { validateEmail } from '../components/auth/validation/validateElements';
import Styles from '../css/index.scss';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default class extends Page {
	static async getInitialProps({ req, query, res }) {
		const props = await super.getInitialProps({ req, res });
		props.pageType = 'increment';

		if (props.session.user) {
			if (res) {
				res.redirect(302, '/');
				res.end();
			} else {
				Router.replace('/');
			}
		}
		return props;
	}
	constructor(props) {
		super(props);
		this.state = {
			emailOpen: false,
			email: '',
			altEmail: '',
			empID: '',
			name: '',
			emailFeedback: '',
			nameFeedback: '',
			empIDFeedback: '',
			altEmailFeedback: '',
			submitted: false,
		};
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleAltEmailChange = this.handleAltEmailChange.bind(this);
		this.handleEmpIDChange = this.handleEmpIDChange.bind(this);
		this.validateAll = this.validateAll.bind(this);
	}

	handleEmailChange(event) {
		this.setState({
			email: event.target.value.trim(),
		});
	}

	handleNameChange(event) {
		this.setState({
			name: event.target.value.trim(),
		});
	}

	handleAltEmailChange(event) {
		this.setState({
			altEmail: event.target.value.trim(),
		});
	}

	handleEmpIDChange(event) {
		this.setState({
			empID: event.target.value.trim(),
		});
	}

	validateAll() {
		if (!validateEmail(this.state.email)) {
			this.setState({ emailValid: false, emailFeedback: 'Please enter valid email address' });
			return false;
		}
		if (this.state.empID.length < 1) {
			this.setState({ empIDValid: false, nameFeedback: 'Please enter your employee ID' });
			return false;
		}
		if (this.state.name.length < 1) {
			this.setState({ nameValid: false, empIDFeedback: 'Please enter your name' });
			return false;
		}
		if (this.state.altEmail.length > 0) {
			if (!validateEmail(this.state.altEmail)) {
				this.setState({ altEmailValid: false, altEmailFeedback: 'Please enter a valid email address' });
				return false;
			}
		}
		this.setState({ emailValid: true, emailFeedback: '' });
		this.setState({ nameValid: true, nameFeedback: '' });
		this.setState({ empIDValid: true, empIDFeedback: '' });
		this.setState({ altEmailValid: true, altEmailFeedback: '' });
		return true;
	}


	handleSubmit = (event) => {
		event.preventDefault();
		if (this.validateAll()) {
			try {
				scroller.scrollTo('main-panel', {
					duration: 500,
					delay: 100,
					smooth: true,
					offset: -72,
				});
				const email = this.state.email.replace('+', '%2B');
				axios({
					method: 'post',
					url: `/api/v1.1/increment`,
					data: {
						email: this.state.email,
						name: this.state.name,
						empID: this.state.empID,
						altEmail: this.state.altEmail,
						type: 'out',
						_csrf: this.props.store._csrf,
					},
				})
					.then((res) => {
						this.setState({ submitted: true });
						// Router.push('/');
					});
			} catch (err) {
				this.props.error = true;
			}
		}
	};

	render() {
		if (this.props.error) {
			return <Error url={this.props.url} />;
		}

		if (this.state.submitted) {
			return (

				<Container style={{
					paddingTop: '1rem', paddingBottom: '5rem', 'max-width': '560px', width: '560vh',
				}}
				>
					<Head>
						<style dangerouslySetInnerHTML={{ __html: Styles }} />
						<title>GiveIndia | Workplace Giving</title>
					</Head>
					<img style={{ paddingBottom: '10' }} src={`${config.cdnUrl}/static/giveindia-a.svg`} width="100" alt="" />

					<Row >
						<div style={{
							background: '#f5f5f5', border: '1px solid rgba(0,0,0,0.1)', width: '100%', textAlign: 'center',
						}}
						>
							<h1 style={{ padding: '1rem' }}> Your response has been recorded.<br />Thank you for your donations! </h1>
						</div>

						<a href={`${config.serverUrl}`} style={{ margin: '1rem', width: '555vh' }}>
							<Button color="primary" className="btn-full-width" style={{ height: '50px !important' }} type="submit" > Explore Our new Monthly Giving Platform </Button>  <div />
						</a>
					</Row>
				</Container>
			);
		}

		return (
			<Container style={{ paddingTop: '1rem', paddingBottom: '5rem', 'max-width': '483px' }}>
				<Head>
					<style dangerouslySetInnerHTML={{ __html: Styles }} />
					<title>GiveIndia | Workplace Giving</title>
					<meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
					<meta charSet="utf-8" />
					<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
				</Head>
				<img style={{ paddingBottom: '10' }} src={`${config.cdnUrl}/static/giveindia-a.svg`} width="100" alt="" />

				<Element name="main-panel">
					<Row >
						<h3> Are you sure you want to opt out? </h3>
						<p>
            A little more from you can help in making a big difference to the people you help!
							<br />
            Continue to be a part of the ‘Pay it Forward’ pledge by just closing this page
							<br />
            If you still want to opt out of the pledge, just fill in the details below
							<br />

						</p>
					</Row	>
					<Row className="py-3">
						<Form id="increment">
							<FormGroup style={{ width: '100%' }}>
								<Input required valid={this.state.nameValid} type="input" name="name" id="name" placeholder="Name" value={this.state.name} onChange={this.handleNameChange} />
								<FormFeedback>{this.state.nameFeedback}</FormFeedback>
							</FormGroup>
							<FormGroup style={{ width: '100%' }}>
								<Input required valid={this.state.empIDValid} type="input" name="empID" id="empID" placeholder="Employee ID" value={this.state.empID} onChange={this.handleEmpIDChange} />
								<FormFeedback>{this.state.empIDFeedback}</FormFeedback>
							</FormGroup>
							<FormGroup style={{ width: '100%' }}>
								<Input required valid={this.state.emailValid} type="email" name="email" id="email" placeholder="Email (registered with GiveIndia)" value={this.state.email} onChange={this.handleEmailChange} />
								<FormFeedback>{this.state.emailFeedback}</FormFeedback>
							</FormGroup>
							<FormGroup style={{ width: '100%' }}>
								<Input valid={this.state.altEmailValid} type="email" name="altEmail" id="altEmail" placeholder="Alternate Email" value={this.state.altEmail} onChange={this.handleAltEmailChange} />
								<FormFeedback>{this.state.altEmailFeedback}</FormFeedback>
							</FormGroup>
							<div style={{
								marginTop: '1rem', marginBottom: '1rem', width: '100%', textAlign: 'center',
							}}
							>

								<Button color="primary" className="btn-full-width" style={{ height: '50px !important' }} type="submit" onClick={this.handleSubmit} > submit </Button>  <div />
								<div className="pt-3" style={{ 'text-align': 'left' }}>
									<p style={{ fontSize: '0.875rem', paddingTop: '0.5rem' }}> Please note that by filling this form you only opt out of increasing your payroll giving contribution by 10% every financial year and not out of the regular payroll giving program
									</p>
								</div>
							</div>
						</Form>
					</Row>
					<Row>
						<br />
						<div>
							<h3>Thank you for your donations.
							</h3>
						</div>
					</Row>
				</Element>
			</Container>
		);
	}
}
